import { render, staticRenderFns } from "./barCode.vue?vue&type=template&id=20359a26&scoped=true&"
import script from "./barCode.vue?vue&type=script&lang=js&"
export * from "./barCode.vue?vue&type=script&lang=js&"
import style0 from "./barCode.vue?vue&type=style&index=0&id=20359a26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20359a26",
  null
  
)

export default component.exports